import { Translation } from '@ps/web-shared-components';
import React from 'react';

import useWizardExit from '@swf/core/hooks/useWizardExit';

import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';
import HelpSupportButton from '../../../HelpSupportButton/HelpSupportButton';

import {
  TXTCLI_Account_Verification,
  TXTWCL_Back_to_homepage,
  TXTWCL_WeXre_still_verifying_the_ID_d_ELL,
  TXTWCL_YouXll_receive_an_email_update_ELL,
  TXTWCL_Your_ID_is_being_verified
} from './RMFPendingVerification.messages.json';

const RMFPendingVerification: React.FunctionComponent = () => {
  const exitWizard = useWizardExit();

  return (
    <Container
      page={RMFPendingVerification}
      headerProps={{
        title: <Translation {...TXTCLI_Account_Verification} />
      }}
      pageTopTitle={<Translation {...TXTWCL_Your_ID_is_being_verified} />}
    >
      <div>
        <Translation {...TXTWCL_WeXre_still_verifying_the_ID_d_ELL} />{' '}
        <Translation {...TXTWCL_YouXll_receive_an_email_update_ELL} />
      </div>
      <CTAButton translation={TXTWCL_Back_to_homepage} type="button" onClick={exitWizard} />
      <div>
        <HelpSupportButton />
      </div>
    </Container>
  );
};

RMFPendingVerification.displayName = 'RMFPendingVerification';

export default RMFPendingVerification;
